import {
    MenubarProps,
} from './types'
import MenubarView from './MenubarView'
import React from 'react'

const Menubar = (props: MenubarProps): React.ReactElement => <MenubarView {...props} />

export default Menubar
